import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const Quote = ({ title, titleId, desc, descId }: SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 96 96"
    aria-labelledby={titleId}
    aria-describedby={descId}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#prefix__a)">
      <path
        fill="#ED0000"
        fillRule="evenodd"
        d="M24.33 7.21A39.3 39.3 0 0 1 39.415 4.2h3.94v13.84l-3.94-.035c-3.37 0-6.705.666-9.818 1.96a25.65 25.65 0 0 0-8.323 5.579 25.75 25.75 0 0 0-5.56 8.35 25.8 25.8 0 0 0-1.953 9.85l.035 3.955h29.56v43.5H0V43.745A39.7 39.7 0 0 1 3 28.61a39.6 39.6 0 0 1 8.544-12.83A39.4 39.4 0 0 1 24.33 7.21m52.646 0A39.3 39.3 0 0 1 92.059 4.2H96v13.84l-3.941-.035c-3.37 0-6.705.666-9.818 1.96a25.65 25.65 0 0 0-8.322 5.579 25.75 25.75 0 0 0-5.561 8.35 25.8 25.8 0 0 0-1.953 9.85l.035 3.955H96v43.5H52.645V43.745a39.7 39.7 0 0 1 3-15.134 39.6 39.6 0 0 1 8.544-12.83A39.4 39.4 0 0 1 76.976 7.21"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <path fill="#fff" d="M0 0h96v96H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Quote;
